export type HeaderFooterPage = 'First' | 'Odd' | 'Even';
export type PowerPointHeaderFooterTarget =
    | 'All slides'
    | 'First slide'
    | 'Handout pages'
    | 'Note pages'
    | 'Title slide';

export type HeaderFooterOptions = {
    sections: string;
    removeMarkings: boolean;
    retainFields: string[];
    pages: HeaderFooterPage[];
    bookmarkPrefix: string;
    insertAtStart: boolean;
    slidesAndPages: PowerPointHeaderFooterTarget[];
    horizontalPosition: number;
    verticalPosition: number;
};

export const defaultHeaderFooterOptions = (bookmarkPrefix = 'Titus'): HeaderFooterOptions => ({
    sections: 'All',
    removeMarkings: false,
    retainFields: [],
    pages: [],
    bookmarkPrefix,
    insertAtStart: true,
    slidesAndPages: ['All slides'],
    horizontalPosition: 0,
    verticalPosition: 0,
});
